import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type TrackSelectedItemsParams } from '../types';

/**
 * Logs event for when a user selectedItem
 */
export const useTrackSelectedItems = () => {
  const { track } = useAnalyticsUtilities();

  const trackSelectedItems = useCallback(
    (params: TrackSelectedItemsParams) => {
      track(`Selected items`, params);
    },
    [track],
  );

  return { trackSelectedItems };
};
